import {useContext} from 'react';
import './styles.scss';
import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../../../../i18n/translations';
import {AppContextType} from '../../../../../../../contexts/app/types';
import {AppContext} from '../../../../../../../contexts/app/context';
import {ThemeMode} from '../../../../../../../enums/theme-mode';
import {Pallete} from '../../../../../../../theme/bluebird';
import {InvitationType} from './renderer';

const Success = ({invitationType}: {invitationType: InvitationType}) => {
  const appContext: AppContextType = useContext(AppContext);

  const {t} = useTranslation();

  // Get title and subtitle
  let title = translations.professional_caregivers.root.modals.add_staff_flow.success.confirm_title;
  let subtitle =
    translations.professional_caregivers.root.modals.add_staff_flow.success.confirm_subtitle;

  // Check type
  if (invitationType === 'quickAccessCode') {
    title =
      translations.professional_caregivers.root.modals.add_staff_flow.success
        .confirm_title_quickAccessCode;
    subtitle =
      translations.professional_caregivers.root.modals.add_staff_flow.success
        .confirm_subtitle_quickAccessCode;
  }

  return (
    <Stack className="content-wrapper">
      <Typography
        component="h3"
        className="title"
        sx={{
          color:
            appContext.state.currentThemeMode === ThemeMode.Light
              ? Pallete.gray.base
              : Pallete.white.base,
        }}
      >
        {t(title)}
      </Typography>
      <Typography
        component="h5"
        className="subtitle"
        sx={{
          color:
            appContext.state.currentThemeMode === ThemeMode.Light ? '#b6b6b6' : Pallete.gray.light,
        }}
      >
        {t(subtitle)}
      </Typography>
    </Stack>
  );
};

export default Success;
